import SlsWebLogger from "js-sls-logger";
import Storage from "good-storage";
import { v4 as uuidv4 } from "uuid";
import { getUserInfo } from "@/utils/common.js";

// 项目标识，这个项目在阿里云日志服务里叫这个名字，跟别的项目(比如campaign-voting-star)
// 区分开，但复用的是同一个project/logstore
const TOPIC = "nrc-user";

const isReleaseEnv = process.env.VUE_APP_LOG_ENV === "release";
// project/logstore 直接复用 campaign-voting-star 那套现成的，不用另外申请
const project = isReleaseEnv ? "jkhh-log-web" : "jkhh-log-test";
const logstore = isReleaseEnv ? "jkhh-h5-log" : "jkhh-test-log";

const logger = new SlsWebLogger({
  host: "cn-beijing.log.aliyuncs.com",
  project,
  logstore,
  time: 0.001,
  count: 1,
});

/**
 * App启动时调用一次：
 * 1. 读URL上的?source=xxx，存起来，这样这次会话期间上报的每一条事件都会自动带上这个渠道来源，
 *    不用每次手动传
 * 2. 检查本地有没有存过这个用户的匿名UUID，没有就生成一个存起来——哪怕用户没登录，
 *    也能有一个稳定的身份用来追踪"这是不是同一个人多次访问"，登录后userId才会有真实值，
 *    两者分开记录，不冲突
 */
export function initTracking() {
  let params = new URLSearchParams(window.location.search);
  let source = params.get("source");
  if (source) {
    Storage.set(`${TOPIC}-source`, source);
  }
  let tempUserId = Storage.get(`${TOPIC}-id`);
  if (!tempUserId) {
    Storage.set(`${TOPIC}-id`, uuidv4());
  }
}

/**
 * 上报一次埋点事件
 * @param page 页面编号，比如 NRCU001
 * @param event 事件编号，比如 NRCU001-001
 * @param properties 事件的额外属性，对象，会被JSON序列化
 */
export function dataGather(page = "", event = "", properties = {}) {
  if (!page || !event) {
    console.warn("埋点页面编号/事件编号不能为空");
    return;
  }
  let p = {
    ...properties,
    tempUserId: Storage.get(`${TOPIC}-id`),
    source: Storage.get(`${TOPIC}-source`),
  };
  let data = {
    __topic__: TOPIC,
    userId: getUserInfo("id") || "",
    openId: getUserInfo("openId") || getUserInfo("h5OpenId") || "",
    pageName: window.PAGE_PATH || window.location.hash,
    eventTime: new Date().getTime(),
    screenHeight: document.documentElement.clientHeight,
    screenWidth: document.documentElement.clientWidth,
    page,
    event,
    properties: JSON.stringify(p),
  };
  logger.send(data);
}
